<template>
    <label :for="id" :class="classes">
        <input
            :id="id"
            type="radio"
            :class="mdsNS('form__radio-button-input')"
            :name="name"
            :value="value"
            :checked="checked"
            :disabled="disabled"
            @click="click"
        />
        <span
            :class="[
                mdsNS('form__radio-button-visible-wrap'),
                namespace('visible-wrap')
            ]"
        >
            <span :class="mdsNS('form__radio-button-visual')"></span>
            <span
                :class="[mdsNS('form__radio-button-text'), namespace('text')]"
                v-html="label"
            >
            </span>
        </span>
    </label>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-radio-button',
    mixins: [mixins],
    props: {
        label: String,
        name: String,
        value: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            validator(value) {
                return utils.inArray(['small', 'large'], value) > -1;
            }
        }
    },
    computed: {
        classes() {
            const cls = [this.mdsNS('form__radio-button')];
            if (this.size) {
                cls.push(this.mdsNS(`form__radio-button--${this.size}`));
            }
            if (this.disabled) {
                cls.push(this.mdsNS('form__radio-button--disabled'));
            }
            cls.push(this.skinStyle);
            return cls;
        }
    },
    created() {
        this.id = utils.guid();
        this.namespace = utils.namespace('ui-radio-button', false);
    },
    methods: {
        click(e) {
            if (!this.disabled) {
                this.$emit('change', {
                    value: this.value,
                    checked: e.target.checked
                });
            }
        }
    }
};
</script>
